import { API, graphqlOperation } from "aws-amplify";
import * as mutations from "../graphql/mutations/connections";
import * as queries from "../graphql/queries/connections";

class ConnectionsAPI implements IConnectionsAPI {
  async adminListConnections() {
    try {
      const response: any = await API.graphql(graphqlOperation(queries.adminListConnections, {}));
      const connections = response.data.adminListConnections as IConnection[];

      return connections;
    } catch (e) {
      throw e;
    }
  }

  async adminGetConnection(connectionId: string) {
    try {
      const response: any = await API.graphql(
        graphqlOperation(queries.adminGetConnection, { connectionId })
      );
      return response.data.adminGetConnection as IConnection;
    } catch (e) {
      throw e;
    }
  }

  async adminUpdateConnection(connection: IConnection) {
    try {
      const response: any = await API.graphql(
        graphqlOperation(mutations.adminUpdateConnection, { input: connection })
      );
      return response.data.adminUpdateConnection as IConnection;
    } catch (e) {
      throw e;
    }
  }

  async adminCreateConnection(connection: IConnection) {
    try {
      const { connectionId, ...$connection } = connection;
      const response: any = await API.graphql(
        graphqlOperation(mutations.adminCreateConnection, { input: $connection })
      );
      return response.data.adminCreateConnection as IConnection;
    } catch (e) {
      throw e;
    }
  }

  async adminDeleteConnection(connectionId: string) {
    try {
      const response: any = await API.graphql(
        graphqlOperation(mutations.adminDeleteConnection, { connectionId })
      );
      return response.data.adminDeleteConnection as IConnection;
    } catch (e) {
      throw e;
    }
  }
}

export default new ConnectionsAPI();
